import React from "react";
import { Grid } from "semantic-ui-react";
import { SidePanel, Form } from "@redriver/cinnamon";
import { FilterButton } from "components/buttons";
import { ClearLabel } from "components/controls";
import { CustomerTypesLookupDropdown } from "features/Customers/CustomerTypesLookup";
import { DepartmentsTypeAhead, UsersTypeAhead } from "components/forms";

export const FieldNames = {
  Search: "search",
  CustomerTypes: "customerType",
  Department: "departmentId",
  DepartmentDisplay: "department",
  CompletedDateFrom: "completedDateFromUtc",
  CompletedDateTo: "completedDateToUtc",
  ContractManager: "contractManagerId",
  ContractManagerDisplay: "contractManager",
};

const JobFilters = ({ formProps, resetFilters }) => {
  return (
    <SidePanel
      closeIcon
      trigger={<FilterButton />}
      className="filter-side-panel"
    >
      <Form {...formProps}>
        <div className="ui header filters-title">
          <div className="title-text">Filters</div>
          <ClearLabel onClick={resetFilters} />
        </div>
        <Grid columns={2}>
          <Grid.Column>
            <CustomerTypesLookupDropdown
              field={FieldNames.CustomerTypes}
              fluid
              multiple
              label="Customer Types"
              placeholder="Select customer type"
            />
          </Grid.Column>
          <Grid.Column>
            <DepartmentsTypeAhead
              field={FieldNames.Department}
              fluid
              label="Department"
              placeholder="Select department"
              clearable
              textField={FieldNames.DepartmentDisplay}
            />
          </Grid.Column>
          <Grid.Column>
            <Form.Date
              instant
              fluid
              field={FieldNames.CompletedDateFrom}
              label="Completed Date From"
              placeholder="Select date"
            />
          </Grid.Column>
          <Grid.Column>
            <Form.Date
              instant
              fluid
              field={FieldNames.CompletedDateTo}
              label="Completed Date To"
              placeholder="Select date"
            />
          </Grid.Column>
          <Grid.Column>
            <UsersTypeAhead
              label="Contract Manager"
              placeholder="Select contract manager"
              field={FieldNames.ContractManager}
              fluid
              clearable
              textField={FieldNames.ContractManagerDisplay}
            />
          </Grid.Column>
        </Grid>
      </Form>
    </SidePanel>
  );
};

export default JobFilters;
